"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("@requestnetwork/types");
const serializable_multi_format_1 = require("../serializable-multi-format");
/**
 * Class to serialize and deserialize multi-format plain text
 */
class Aes256CbcMultiFormat extends serializable_multi_format_1.default {
    constructor() {
        super(types_1.MultiFormatTypes.prefix.PLAIN_TEXT, types_1.MultiFormatTypes.PlainTypes.TYPE.PLAIN_TEXT);
    }
}
exports.default = Aes256CbcMultiFormat;
